import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { MessageSquare, User } from 'lucide-react';
import { BRAND_COLORS, BRAND_LABELS } from '@/constants/bluemonk';

export const CommentsTab = ({ comments, onNavigate }) => {
  if (comments.length === 0) {
    return (
      <Card className="p-8 text-center">
        <MessageSquare className="h-12 w-12 text-slate-400 mx-auto mb-4" />
        <p className="text-lg font-medium text-slate-700">No comments yet</p>
        <p className="text-slate-500">Comments will appear here as you interact</p>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {comments.map((comment) => {
        const colors = BRAND_COLORS[comment.brand];
        return (
          <Card key={comment.id} className="p-4">
            <div className="flex items-start gap-4">
              <div className="h-10 w-10 rounded-full bg-slate-200 flex items-center justify-center flex-shrink-0">
                <User className="h-5 w-5 text-slate-500" />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-semibold text-slate-900">{comment.author?.name}</span>
                  <Badge variant={comment.authorType === 'admin' ? 'default' : 'outline'} className="text-xs">
                    {comment.authorType === 'admin' ? 'Content Vista' : 'Client'}
                  </Badge>
                  <Badge className={`${colors.badge} text-white text-xs`}>
                    {BRAND_LABELS[comment.brand]}
                  </Badge>
                </div>
                <p className="text-sm text-slate-600 mb-2">{comment.content}</p>
                <div className="flex items-center gap-4 text-xs text-slate-400">
                  <span>{new Date(comment.createdAt).toLocaleString()}</span>
                  <button
                    onClick={() => onNavigate(comment.itemId, comment.itemType)}
                    className="text-primary hover:underline"
                  >
                    View: {comment.itemTitle}
                  </button>
                </div>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};
